import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {LABS} from '../mock-labs';
import {Lab} from '../lab';
import {Task} from '../task';

@Component({
  selector: 'app-left-sidebar',
  templateUrl: './left-sidebar.component.html',
  styleUrls: ['./left-sidebar.component.css']
})
export class LeftSidebarComponent implements OnInit {
  public labs:Array<Lab>;
  selectedLab:Lab;
  selectedTask:Task;

  constructor(
    public  router:Router
  ) {
    this.labs = LABS;

  }

  ngOnInit() {

  }
  navTo(lab:Lab,task:Task){
    this.router.navigateByUrl('labs/'+lab.id+'/tasks/'+task.id);
  }
  onSelect(lab:Lab,task:Task){
    this.selectedLab = lab;
    this.selectedTask = task;
    console.log("selected Lab"+lab.id);
    console.log("selected Task"+task.id);
  }
}
